import React, {useState} from 'react';
import "../../css/gardenManagerStylings/GardenManagerHeaderCardStyling.css";
import CustomDropdown from "../reusableComponents/CustomDropdown";
import GardenAlert from "../reusableComponents/GardenAlert";

const GardenManagerHeaderCard = ({ gardens, selectedGarden, setSelectedGarden, handleWateringGardens, handleAddingEvent }) => {

    const [showAlert, setShowAlert] = useState(false);

    const handleGardenChange = (e) => {
        const selectedGardenName = e.target.value;
        const selectedGardenObj = gardens.find(garden => garden.name === selectedGardenName);
        setSelectedGarden(selectedGardenObj);
    };

    const handleWaterClick = () => {
        if (selectedGarden) {
            handleWateringGardens(selectedGarden);
        } else {
            setShowAlert(true);
            setTimeout(() => setShowAlert(false), 3000);
        }
    };

    const handleAddEventClick = () => {
        handleAddingEvent();
    }

    const hasPlantedPlants = (garden) => {
        if (!garden?.plants || garden.plants.length === 0) {
            return false;
        }

        // Return true if there's at least one planted plant
        const plantedPlants = garden.plants.filter(plant =>
            plant.plant_status !== null &&
            plant.plant_status !== undefined &&
            plant.plant_status !== 'planned'
        );

        return plantedPlants.length > 0; // Changed from === to >
    }

    // Check if garden was already watered today
    const today = new Date().toISOString().split('T')[0];
    const isWateredToday = selectedGarden?.plants?.some(plant =>
        plant.last_watered === today
    );
    const plantedPlants = hasPlantedPlants(selectedGarden);

    return (
        <div className="garden-manager-header-card">
            <div className={`garden-manager-header-card-body`}>
                <div className={`garden-manager-title-and-selector`}>
                    <div className={`garden-manager-header-card-title`}>
                        <p>Garden Manager</p>
                    </div>
                    <div className={`garden-manager-header-card-garden-selector`}>
                        <CustomDropdown
                            options={gardens}
                            value={selectedGarden?.name}
                            onChange={(garden) => setSelectedGarden(garden)}
                            placeholder="Select a garden..."
                            className="garden-dropdown-custom"
                        />
                    </div>
                </div>

                {selectedGarden && plantedPlants && (
                    <div className="action-buttons">
                        <button
                            className={`header-button ${isWateredToday ? 'already-watered' : ''}`}
                            onClick={handleWaterClick}
                            disabled={isWateredToday}
                            title={isWateredToday ? 'Garden already watered today' : 'Water all plants in garden'}
                        >
                            {isWateredToday ? '✅ Watered Today' : '💧 Water Garden'}
                        </button>
                        <button className="header-button" onClick={handleAddEventClick}>
                            📋 Add Event

                        </button>
                    </div>
                )}
            </div>

            {showAlert && (
                <GardenAlert
                    alertSubject="No Garden Selected"
                    alertMessage="Please select a garden before performing this action."
                    alertType="Error"
                    isVisible={showAlert}
                    onClose={() => setShowAlert(false)}
                />
            )}
        </div>
    )
}

export default GardenManagerHeaderCard;